function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9276 32.114C32.5799 32.1473 40.5 25.0591 40.5 16.4401C40.5 7.02246 32.5799 0.5 23.9276 0.5H16.4734C7.7213 0.5 0.5 7.02246 0.5 16.4401C0.5 25.0591 7.7213 32.1473 16.4734 32.114H23.9276Z",
  fill: "#006095"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8012 24.8594V7.72131C23.2621 9.05243 25.6913 12.3802 25.6913 16.2737C25.6913 20.2005 23.2621 23.5283 19.8012 24.8594ZM7.32196 16.2737C7.32196 12.3802 9.78452 9.01915 13.2121 7.72131V24.8594C9.78452 23.5283 7.32196 20.2005 7.32196 16.2737ZM16.5066 1.79785C8.48668 1.79785 1.9975 8.28704 1.9975 16.2737C1.9975 24.2604 8.48668 30.7496 16.5066 30.7496C24.5266 30.7496 31.0158 24.2604 31.0158 16.2737C31.0158 8.28704 24.5266 1.79785 16.5066 1.79785Z",
  fill: "white"
});
function SvgDinersclub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersclub);
export default __webpack_public_path__ + "static/media/dinersclub.56d41159.svg";
export { ForwardRef as ReactComponent };